export default "__VITE_ASSET__BxmK23jU__"